import axios from "axios";
import * as config from "../../../app.config";
import { useQuery } from "react-query";
import { setHeaders } from "../../../utils/basic";
import { isObjectEmptyNull } from "../../../utils/basic";


const fetchDdpcr1DGraphById = async (graphVar) => {
    const { plateId, wellId } = graphVar;
    const headerConfig = setHeaders();

    const { data: urlWrapper } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/graph/oned/${plateId}/${wellId}`,
        { headers: headerConfig }
    );
    const { data: graphData } = await axios.get(urlWrapper.signedUrl);
    return graphData;
};

export default function useFetchDdpcr1DGraphData(graphVar) {
    return useQuery(["1DGraph", graphVar], () => fetchDdpcr1DGraphById(graphVar), {

        enabled: !isObjectEmptyNull(graphVar),
        onSuccess: (data) => {
            console.log(data);
        },
        refetchOnWindowFocus : false
    });
}
